import cookie from 'react-cookie';
import config from '../../config';
import { generatePerkCode } from '../../common/api/promotions';
import { stopSubmitSpinner, startSubmitSpinner } from './interactions';

export const SET_SELECTED_PERK = 'SET_SELECTED_PERK';
export const FETCH_PERK_SUCCESS = 'FETCH_PERK_SUCCESS';
export const FETCH_PERK_CODE_FAILURE = 'FETCH_PERK_CODE_FAILURE';

export const fetchPerkCode = perkId => async (dispatch) => {
  if (!perkId) {
    return dispatch({ type: FETCH_PERK_CODE_FAILURE, message: 'A valid perkId is required.' });
  }
  dispatch({ type: SET_SELECTED_PERK, selectedPerk: perkId, perkCode: null });
  try {
    dispatch(startSubmitSpinner());
    const { company: brand } = config;
    const accessToken = cookie.load('access_token');
    const { code } = await generatePerkCode(perkId, accessToken, brand);
    dispatch(stopSubmitSpinner());
    return dispatch({ type: FETCH_PERK_SUCCESS, perkCode: code, perkId });
  } catch (err) {
    const { message } = err;
    dispatch(stopSubmitSpinner());
    return dispatch({ type: FETCH_PERK_CODE_FAILURE, message });
  }
};
